module.exports = __webpack_public_path__ + "img/unprotected.37377de9.svg";